import { message } from "antd";
import { useLanguage } from "../context/LanguageContext";
import messageTranslations from "../utils/messageContent";

const useFeedbackService = () => {
  const { language } = useLanguage();
  const t = messageTranslations[language] || messageTranslations["de"];

  const saveFeedback = async (payload) => {
    try {
      console.log(payload);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedback/savefeedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(t.feedback?.saveError || "Fehler beim Speichern.");
      }

      const data = await response.json();
      message.success(t.feedback?.saveSuccess || "Feedback gespeichert.");
      return data;
    } catch (error) {
      console.error("Save Feedback:", error);
      message.error(error.message);
      return null;
    }
  };

  const getHomeData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedback/getHomeData`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      return await response.json();
    } catch (err) {
      console.log(err);
      return null;
    }
  };

  const getFeedbackDashboardMetricData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedback/getMetricFeedbackDashboard`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(t.feedback?.dashboardError);
      }

      return await response.json();
    } catch (error) {
      console.error("Dashboard Metrics:", error);
      return null;
    }
  };

  const getOverviewMetrics = async (timeRange) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedback/overview-metrics?timeRange=${timeRange}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(t.feedback?.overviewError);
      }

      return await response.json();
    } catch (error) {
      console.error("Overview Metrics:", error);
      return null;
    }
  };

  const getChartMetrics = async (timeRange) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedback/chart-metrics?timeRange=${timeRange}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(t.feedback?.chartError);
      }

      return await response.json();
    } catch (error) {
      console.error("Chart Metrics:", error);
      return null;
    }
  };
  const getAllFeedbacksForUser = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedback/user-feedbacks`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          t.feedback?.fetchAllError || "Fehler beim Abrufen der Feedbacks."
        );
      }

      const data = await response.json();
      return data.feedbacks; // Nur die Feedbacks zurückgeben
    } catch (error) {
      console.error("Get All Feedbacks:", error);
      message.error(error.message);
      return [];
    }
  };

  const getAllFeedbacksForUserAndQuestion = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedback/user-feedbacksQuestion`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          t.feedback?.fetchAllError || "Fehler beim Abrufen der Feedbacks."
        );
      }

      const data = await response.json();
      return data.feedbacks; // Nur die Feedbacks zurückgeben
    } catch (error) {
      console.error("Get All Feedbacks:", error);
      message.error(error.message);
      return [];
    }
  };

  return {
    saveFeedback,
    getHomeData,
    getFeedbackDashboardMetricData,
    getOverviewMetrics,
    getChartMetrics,
    getAllFeedbacksForUser,
    getAllFeedbacksForUserAndQuestion,
  };
};

export default useFeedbackService;
